import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5fd8b00d")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modal" }, null, -1)
const _hoisted_2 = {
  id: "app",
  class: "relative"
}
const _hoisted_3 = { class: "text flex justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Account", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueQueryDevTools = _resolveComponent("VueQueryDevTools")!
  const _component_WalletSelectModal = _resolveComponent("WalletSelectModal")!
  const _component_SanctionedWalletModal = _resolveComponent("SanctionedWalletModal")!
  const _component_ThirdPartyServicesModal = _resolveComponent("ThirdPartyServicesModal")!
  const _component_AppSidebar = _resolveComponent("AppSidebar")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_GlobalModalContainer = _resolveComponent("GlobalModalContainer")!
  const _component_x = _resolveComponent("x")!
  const _component_MobileWallet = _resolveComponent("MobileWallet")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout))),
      _createVNode(_component_VueQueryDevTools),
      _createVNode(_component_WalletSelectModal, {
        isVisible: _ctx.isWalletSelectVisible,
        onShowThirdParty: () => _ctx.handleThirdPartyModalToggle(true, 'wallet'),
        onClose: _ctx.toggleWalletSelectModal
      }, null, 8, ["isVisible", "onShowThirdParty", "onClose"]),
      (_ctx.isSanctioned)
        ? (_openBlock(), _createBlock(_component_SanctionedWalletModal, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_ThirdPartyServicesModal, {
        isVisible: _ctx.isThirdPartyServicesModalVisible,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleThirdPartyModalToggle(false, 'third')))
      }, null, 8, ["isVisible"]),
      (_ctx.sidebarOpen)
        ? (_openBlock(), _createBlock(_component_AppSidebar, {
            key: 1,
            onToggleMobileWallet: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMobileWallet = true))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Notifications)
    ]),
    _createVNode(_component_GlobalModalContainer),
    (_ctx.showMobileWallet)
      ? (_openBlock(), _createBlock(_component_BalModal, {
          key: 0,
          show: "",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMobileWallet = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_x, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMobileWallet = false))
                })
              ]),
              _createVNode(_component_MobileWallet)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}